module.exports = __webpack_public_path__ + "img/stream-solid.6338edbb.svg";